module.exports = __webpack_public_path__ + "img/rabbit_face.6bf8cbd6.gif";